import React from "react";
import PropTypes from "prop-types";

import { Form } from "..";

export function FormDropdown({
  id,
  name,
  description,
  options,
  value,
  required,
  errorMessage,
  disabled,
  disableClearable,
}) {
  return (
    <Form.Dropdown
      name={id}
      label={name}
      description={description}
      disableClearable={disableClearable}
      includeInputInList
      initialValue={value}
      data-test="form-dropdown"
      placeholder="Select a value"
      required={required}
      errorMessage={errorMessage}
      options={options}
      disabled={disabled}
    />
  );
}

FormDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  description: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  disableClearable: PropTypes.bool,
};

FormDropdown.defaultProps = {
  description: "",
  value: null,
  required: true,
  errorMessage: "Please select a value",
  disabled: false,
  disableClearable: false,
};

export default FormDropdown;
